import { Text, Tooltip } from "@mantine/core";

import { formatUtc } from "./format";

type Props = {
  value: string | null | undefined;
  /** Show local browser time with the UTC value in a tooltip (non-finance screens). */
  local?: boolean;
  /** Date only. */
  dateOnly?: boolean;
};

/** UTC date-time with a "UTC" suffix, or local time with a UTC tooltip (spec §2.5). */
export function DateUTC({ value, local, dateOnly }: Props) {
  if (!value)
    return (
      <Text span c="dimmed">
        —
      </Text>
    );
  const utc = formatUtc(value, !dateOnly);
  if (!local)
    return (
      <Text span fz="inherit" style={{ whiteSpace: "nowrap" }}>
        {utc}
      </Text>
    );
  const d = new Date(value);
  const shown =
    dateOnly ? d.toLocaleDateString() : d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  return (
    <Tooltip label={utc}>
      <Text span fz="inherit" style={{ whiteSpace: "nowrap" }}>
        {shown}
      </Text>
    </Tooltip>
  );
}
